export default __webpack_public_path__ + "navigation-examples-route-deserialize-thumbnail-480-88848d3c6e6c95fc9f9cbadf5650b90a.webp";